export default __webpack_public_path__ + "static/tower-2448640976d9cb95c1bc1c444f711a7e.svg";